<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <div *ngIf="survey?.buildings[0]?.block?.handoverMode">
      <div class="sub-title-container">
        <span class="sub-title" i18n="@@survey.inside.validate.handover">Handover Mode</span>
      </div>
      <div class="handover-text">
        <p i18n="@@survey.inside.validate.handover.text">This Building is currently in handover mode, any changes to the survey won't be pushed to back-end systems.</p>
      </div>
    </div>
    <div *ngIf="survey?.hasFailedValidateSurvey" class="margin-bottom">
      <div class="sub-title-container error">
        <span class="sub-title" i18n="@@survey.inside.validate.error">Error during validation</span>
      </div>
      <div class="error-text">
        <p i18n="@@survey.inside.validate.error.text">An occured has occured while synchronizing this Survey to the back-end systems.</p>
      </div>
      <div class="btn-group inline">
        <button
          class="btn-error"
          (click)="navigateToCommand()"
          i18n="@@survey.inside.validate.button.details"
        >
          View details
        </button>
      </div>
    </div>
    <div *ngIf="survey?.hasOngoingValidateSurvey" class="margin-bottom">
      <div class="sub-title-container error">
        <span class="sub-title" i18n="@@survey.outside.validate.error">Ongoing validation</span>
      </div>
      <div class="error-text">
        <p i18n="@@survey.outside.validate.error.text">The syncronization with the back end systems is still ongoing.</p>
      </div>
    </div>
    <div *ngIf="survey?.hasSucceededValidateSurvey" class="margin-bottom">
      <div class="sub-title-container error">
        <span class="sub-title" i18n="@@survey.outside.validate.error">Scyncronization Succesfull</span>
      </div>
    </div>
    <div class="sub-title-container">
      <span class="sub-title" i18n="@@general.remarks">Remarks</span>
    </div>
    <div>
    <div class="textarea-container">
      <textarea
        class="remarks"
        placeholder="add validation remarks..."
        [(ngModel)]="remarks"
        (ngModelChange)="remarkChanged($event)"
      ></textarea>
    </div>
    <div class="btn-group">
      <button
        class="btn-validate"
        [class.disabled]="disableValidate"
        (click)="onValidate()"
        i18n="@@general.validate"
      >
        Validate
      </button>
      <button
        class="btn-reject"
        [class.disabled]="isSurveyBlockedByOngoingSync"
        (click)="onReject()"
        i18n="@@survey.inside.validate.button.back"
      >
        Back to ongoing
      </button>
    </div>
    <div class="surveyor-name-wrap">
      <mat-icon class="material-icons-outlined"> inventory </mat-icon>
      <span class="surveyor-name">{{ fullName }}</span>
    </div>
  </div>
</div>
